import React, { useEffect, useState } from 'react';
import { fr } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Input } from './ui/input';

const pad = (n) => String(n).padStart(2, '0');
export const isoToFr = (iso) => (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.split('-').reverse().join('/') : '');
const frToIso = (s) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || '');
  if (!m) return '';
  const d = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  return d.getDate() === Number(m[1]) && d.getMonth() === Number(m[2]) - 1 ? `${m[3]}-${m[2]}-${m[1]}` : '';
};
const masque = (v) => {
  const c = v.replace(/\D/g, '').slice(0, 8);
  return [c.slice(0, 2), c.slice(2, 4), c.slice(4, 8)].filter(Boolean).join('/');
};

// Saisie JJ/MM/AAAA ou choix au calendrier ; valeur exposée au format ISO (YYYY-MM-DD) ou ''.
export function DateFrInput({ value, onChange, placeholder = 'JJ/MM/AAAA', testId }) {
  const [texte, setTexte] = useState(isoToFr(value));
  const [open, setOpen] = useState(false);
  useEffect(() => { setTexte(isoToFr(value)); }, [value]);
  const invalide = texte.length === 10 && !frToIso(texte);
  const selected = value ? new Date(`${value}T12:00:00`) : undefined;

  return (
    <div className="flex items-center gap-1">
      <Input
        value={texte} placeholder={placeholder} inputMode="numeric"
        onChange={(e) => {
          const t = masque(e.target.value);
          setTexte(t);
          if (!t) onChange('');
          else if (t.length === 10 && frToIso(t)) onChange(frToIso(t));
        }}
        className={`h-8 text-sm font-mono ${invalide ? 'border-red-400' : ''}`}
        data-testid={testId}
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" className="h-8 w-8 shrink-0 rounded-md border border-indigo-200 bg-white text-indigo-600 hover:bg-indigo-50 flex items-center justify-center"
            data-testid={`${testId}-calendar-btn`} aria-label="Ouvrir le calendrier">
            <CalendarDays className="h-4 w-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar mode="single" locale={fr} selected={selected} defaultMonth={selected}
            onSelect={(d) => {
              if (d) onChange(`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`);
              setOpen(false);
            }} />
        </PopoverContent>
      </Popover>
    </div>
  );
}
